import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient("https://iudzzeqvihyxbzdvooeq.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1ZHp6ZXF2aWh5eGJ6ZHZvb2VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5Nzc4MDcsImV4cCI6MjA3MjU1MzgwN30.KcSOr8Oa0fnSaeWWBNXZy0osMOdL2od_tJ3vOV_-c44");

export default function AuthCallback() {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const ranRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    (async () => {
      try {
        const url = new URL(window.location.href);
        const code = url.searchParams.get("code");
        const err = url.searchParams.get("error_description");
        
        if (err) { 
          setError(decodeURIComponent(err)); 
          setIsLoading(false);
          return; 
        }
        
        if (!code) { 
          setError("Code OAuth manquant."); 
          setIsLoading(false);
          return; 
        }

        // Anti "refresh/retour arrière" : ne traite chaque code qu'une seule fois
        const key = `oauth-code-used:${code}`;
        if (sessionStorage.getItem(key)) {
          // on a déjà échangé ce code — rediriger vers le dashboard
          window.history.replaceState({}, "", "/");
          navigate("/");
          return;
        }
        sessionStorage.setItem(key, "1");

        const { error } = await supabase.auth.exchangeCodeForSession({ code });
        if (error) { 
          setError(error.message); 
          setIsLoading(false);
          return; 
        }

        // Purge l'URL et rediriger vers le dashboard
        window.history.replaceState({}, "", "/");
        navigate("/");
        
      } catch (err) {
        setError("Erreur lors de la connexion: " + err.message);
        setIsLoading(false);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <div className="text-center">
        {isLoading && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600 mx-auto mb-4"></div>
            <p className="text-slate-600 text-lg">Connexion en cours…</p>
          </>
        )}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
            <p className="text-red-600 font-semibold mb-4">Erreur de connexion</p>
            <p className="text-red-500 text-sm mb-4">{error}</p>
            <button 
              onClick={() => navigate("/")}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Retour à la connexion
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
